const isReadonlyArray: <T = any>(value: unknown) => value is readonly T[] =
  Array.isArray;

export default isReadonlyArray;
